import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'step-logo',
    templateUrl: './step-logo.component.html',
    styleUrls: ['./step-logo.component.scss'],
    standalone: false
})
export class StepLogoComponent implements OnInit {
  @Input() step: string;
  @Input() category: string;
  @Input() categorizedData: any;

  tooltip = '';
  tooltipClass = '';
  constructor() {}

  ngOnInit(): void {}
}
